import { csx, cx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    background:
      'repeating-linear-gradient(45deg,rgba(255,0,0,0.15) 0,rgba(255,0,0,0.15) 10px,transparent 10px,transparent 20px)',
  }),
}

type Props = {
  children: React.ReactNode
  className?: string
}

export function RemoveMe(props: Props) {
  const { children, className = '' } = props
  return <div className={cx(styles.container, className)}>{children}</div>
}
